// @ts-nocheck
import axios from 'config/api';
import { store } from '../App';
import { HIDE_FULLSCREEN_LOADER } from '../redux/actions/loader';
import { errorToast } from './toastHandler';
import getCookie from './getCookie';
import { CONFIG } from 'config/environment_variables';

const SOMETHING_WENT_WRONG = 'Something went wrong.';
const COULD_NOT_CONNECT_TO_SERVER = 'Could not connect to server.';
let tenant: string | null = null;

const getTenant = () => {
  if (tenant === null) {
    tenant = localStorage.getItem('tenant');
  }
  return tenant;
};

const getAuthorizationHeader = (token: string) =>
  CONFIG.APP_PLATFORM === 'django'
    ? {
        'X-CSRFToken': getCookie('csrftoken'),
        'tenant-id': getTenant(),
      }
    : {
        Authorization: token ? `Bearer ${token}` : '',
        'tenant-id': getTenant(),
      };

const getData = (data: unknown) =>
  Object.keys(data).includes('data') ? data?.data : data;

export const fetchGetApi = async (url: string, token: string) => {
  try {
    const header = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...getAuthorizationHeader(token),
      },
    };

    const data = await axios.get(url, header);
    if (data.status === 200) {
      return getData(data);
    }
  } catch (error) {
    if (error.response) {
      errorToast(
        error.response.data.error
          ? error.response.data.error
          : SOMETHING_WENT_WRONG,
      );
    } else if (error.request) {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    } else {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    }
  }
};

export const fetchPostApi = async (url, payload, token) => {
  try {
    const header = {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        ...getAuthorizationHeader(token),
      },
      data: JSON.stringify(payload),
    };

    const data = await axios({
      url,
      ...header,
    });

    if (data.status === 200 || data.status === 201) {
      return getData(data);
    }

    const { loader } = store.getState().global.loader;
    if (loader) {
      store.dispatch({ type: HIDE_FULLSCREEN_LOADER });
    }
  } catch (error) {
    const { loader } = store.getState().global.loader;
    if (loader) {
      store.dispatch({ type: HIDE_FULLSCREEN_LOADER });
    }
    if (error.response) {
      errorToast(
        error.response.data.error
          ? error.response.data.error
          : SOMETHING_WENT_WRONG,
      );
    } else if (error.request) {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    } else {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    }
  }
};

export const fetchPutApi = async (url, payload, token) => {
  try {
    const header = {
      method: 'PUT',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        ...getAuthorizationHeader(token),
      },
      data: JSON.stringify(payload),
    };

    const data = await axios({
      url,
      ...header,
    });

    if (data.status === 200 || data.status === 201) {
      return getData(data);
    }
    const { loader } = store.getState().global.loader;
    if (loader) {
      store.dispatch({ type: HIDE_FULLSCREEN_LOADER });
    }
  } catch (error) {
    const { loader } = store.getState().global.loader;
    if (loader) {
      store.dispatch({ type: HIDE_FULLSCREEN_LOADER });
    }
    if (error.response) {
      errorToast(
        error.response.data.error
          ? error.response.data.error
          : SOMETHING_WENT_WRONG,
      );
    } else if (error.request) {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    } else {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    }
  }
};

export const fetchDelApi = async (url, token) => {
  try {
    const header = {
      method: 'DELETE',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        ...getAuthorizationHeader(token),
      },
    };

    const data = await axios.delete(url, header);

    if (data.status === 200) {
      return getData(data);
    }
  } catch (error) {
    if (error.response) {
      errorToast(
        error.response.data.error
          ? error.response.data.error
          : SOMETHING_WENT_WRONG,
      );
    } else if (error.request) {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    } else {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    }
  }
};

export async function postFormData(url, method, payload, token) {
  const multipart = new FormData();

  Object.keys(payload).forEach((key) => {
    if (payload[key] !== null) {
      Array.isArray(payload[key])
        ? multipart.append(key, JSON.stringify(payload[key]))
        : multipart.append(key, payload[key]);
    }
  });

  try {
    const { data } = await axios[method](url, multipart, {
      headers: {
        Accept: '*/*',
        'Content-Type': 'multipart/form-data',
        ...getAuthorizationHeader(token),
      },
    });
    return data;
  } catch (error) {
    store.dispatch({ type: HIDE_FULLSCREEN_LOADER });
    if (error.response) {
      errorToast(
        error.response.data.error
          ? error.response.data.error
          : SOMETHING_WENT_WRONG,
      );
    } else if (error.request) {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    } else {
      errorToast(COULD_NOT_CONNECT_TO_SERVER);
    }
  }
}
